interface BillingAddress {
  country?: string | null;
  city?: string | null;
}

export const isBillingAddressComplete = (
  address: BillingAddress,
  line1: string,
) => Boolean(line1.trim() && address.country && address.city);

export const returnToPlanSelection = (
  event: {preventDefault: () => void},
  activatePlans: () => void,
  showPlanSelection: () => void,
  navigate: (path: string) => void,
) => {
  event.preventDefault();
  activatePlans();
  showPlanSelection();
  navigate('/workspace-settings/billing');
};
